function hasOnlyProperty(obj: any, key: string) {
  if (obj === undefined || obj === null || typeof obj !== 'object') {
    return false;
  }

  const properties = Object.getOwnPropertyNames(obj);
  return properties.length === 1 && properties[0] === key;
}

export default hasOnlyProperty;
